export const DATE_FORMAT = 'MM/dd/yyyy';
export const LONG_DATE_FORMAT = "dd MMMM yyyy";
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DAYS_OFFSET = 24 * 60 * 60;
export const WEEKS_OFFSET = 7 * DAYS_OFFSET;
export const MONTHS_OFFSET = 30 * DAYS_OFFSET; 